import React from 'react';
import CAppFilterSelect from '../../../../../../../app/components/CAppFilterSelect';
import IInvestExpertiseFilters from '../../../../../interfaces/expertise/IInvestExpertiseFilters';
import { useTranslation } from 'react-i18next';
import investmentFilterLang from '../../../langs/investmentFilterLang';
import { TInvestFundSfdrTag } from '../../../../../types/fund/TInvestFundSfdrTag';

type CFiltersSfrdSelectProps = {
	optionsSFRD: { id: TInvestFundSfdrTag; name: string }[];
	filters: IInvestExpertiseFilters;
	onChange: (filters: IInvestExpertiseFilters) => void;
};

const CFiltersSfrdSelect = (props: CFiltersSfrdSelectProps) => {
	const { optionsSFRD, filters, onChange } = props;

	const { t } = useTranslation();

	return (
		<CAppFilterSelect
			className="filter-sfdr"
			label={t(investmentFilterLang.sfdr.tag)}
			value={filters && filters.sfdr !== undefined ? optionsSFRD.find((x) => x.id === filters.sfdr) : null}
			onChange={(val: { id: TInvestFundSfdrTag; name: string }) => {
				onChange({
					...filters,
					sfdr: val ? val.id : undefined,
				});
			}}
			size="small"
			options={optionsSFRD}
		/>
	);
};

export default CFiltersSfrdSelect;
